import momentWithLocale from '../local_moment';
import {
  controller_project_exclude_features as cpef,
  controller_type_exclude_features as ctef
} from '../Constants/ControllerFeatures';
import { resolutions } from '../Constants/constants';

// import createModule from '../glue.mjs';

const HISTORY_TYPES = [
  'time',
  'humidity',
  'temp',
  'co2',
  'vpd',
  'temp_leaf_current',
  'vol_water_content',
  'ec_root_zone',
  'vol_water_content_2',
  'ec_root_zone_2',
  'vol_water_content_3',
  'ec_root_zone_3',
  'vol_water_content_4',
  'ec_root_zone_4'
];

// export const wasm = createModule().then((Module) => ({
//   fromBinary: Module.cwrap('MsgpackToString', 'string', ['array', 'number']),
//   toBinary: Module.cwrap('StringToMsgpack', 'string', ['string'])
// }));

export function CreateControllerWSRequest(socket, controller_id, command, data = {}) {
  let req = {};
  req.internal_id = controller_id;
  req.cookie = document.cookie;
  req.data = data;
  req.command = command;
  req.socket = socket;
  return req;
}

export function CreateGlobalWSRequest(socket, command, data = {}) {
  let req = {};
  req.cookie = document.cookie;
  req.internal_id = '###global###';
  req.data = data;
  req.command = command;
  req.socket = socket;
  return req;
}

export function HandleAction(
  wsManager,
  controller,
  type,
  value,
  zone_id,
  t = undefined,
  enqueueSnackbar = undefined
) {
  if (controller?.connection?.status !== 'good') return false;
  let data = { id: type, value: 0 };

  if (value !== undefined) {
    if (Number.isInteger(Number.parseInt(value))) {
      data['value'] = Number.parseInt(value);
    } else {
      return;
    }
  }

  if (zone_id !== undefined) {
    if (Number.isInteger(Number.parseInt(zone_id))) {
      data['zone_id'] = Number.parseInt(zone_id);
    } else {
      return;
    }
  }

  if (type === 'action_erase_flash') {
    // Flash
    const keepPrevFlashValue = JSON.parse(localStorage.getItem('prevFlashValue')) || {
      triggered_flash: false,
      free: controller.fs_status.free
    };

    enqueueSnackbar(t('start_erase_flash'), { variant: 'info' });
    localStorage.setItem(
      'prevFlashValue',
      JSON.stringify({
        triggered_flash: true,
        free: keepPrevFlashValue.free
      })
    );
  }

  return wsManager.sendWSMsg(controller, 'action', data, false, isZoned(controller), false);
}

export function DeepCopyObj(obj) {
  return JSON.parse(JSON.stringify(obj));
}

// Converts timing settings and replaces all 0xffff values with -1
export function convert_settings(settings) {
  Object.keys(settings).forEach(function (category, _) {
    Object.keys(settings[category]).forEach(function (key) {
      if (settings[category][key] === 0xffff) settings[category][key] = -1;
    });
  });
  return settings;
}

export function RemoveMessageDuplicates(messages) {
  let new_messages = [];
  messages.forEach((message) => {
    const existing = new_messages.filter((x, i) => {
      return x['id'] === message['id'];
    });
    if (existing.length === 0) new_messages.push(message);
  });
  return new_messages;
}

export function RemoveMessageOfController(messages, controller_id) {
  let new_messages = [];
  messages.forEach((message) => {
    if (message['controller_id'] !== controller_id) new_messages.push(message);
  });
  return new_messages;
}

export function Ran(min, max, without) {
  while (true) {
    var num = Number.parseInt(Math.random() * (max + 1 - min) + min, 10);
    if (num !== without) return num;
  }
}

export function addZ(value) {
  return value < 10 ? '0' + value : value;
}

export function ParseFloat(number, format) {
  let str = Number.parseFloat(number).toFixed(1);
  return format === '.' ? str : str.replace('.', format);
}

export function TransformHistoryValue(value, type) {
  if (value === -1 || value === 0xffff) {
    return -1;
  } else if (type === 'co2' || type === 'time') {
    return value;
  }
  return Number.parseFloat(value / 10);
}

export function UpdateHistory(history, data, options = {}) {
  const { supportsStableTransferId = false } = options;
  const is_start_packet = data.part === 0 || data.progress === 0;
  const is_recent = history.resolution === resolutions.recent;
  let has_active_transfer = history.pending_data.length > 0;
  const packet_transfer_id = data.timestamp ?? null;
  const current_transfer_id = history.pending_transfer_id ?? null;

  if (!supportsStableTransferId) {
    history.pending_data.push(data);
    history.progress = data['progress'];
    if (data.time.length > 0) {
      history.last_ts = data.time[data.time.length - 1];
    } else {
      var legacy_date = new Date();
      history.last_ts = legacy_date.getTime();
    }
    if (data['progress'] === 100) {
      history.pending_data.sort((a, b) => a.part - b.part);
      ClearHistoryValues(history);
      for (const pending of history.pending_data) {
        UpdateHistoryValues(history, pending);
      }
      NormalizeHistoryOrder(history);
      history.pending_data = [];
      history.pending_transfer_id = null;
      history.transfer_mode = 'legacy';
      history.incomplete_final_chunk = false;
      history.orphan_final_chunk = null;
    }
    return history;
  }

  const resetPendingTransfer = () => {
    const orphan = history.orphan_final_chunk;
    const preserveOrphan =
      !is_recent &&
      orphan !== null &&
      (packet_transfer_id === null ||
        orphan.timestamp === null ||
        orphan.timestamp === packet_transfer_id);
    history.pending_data = [];
    history.pending_transfer_id = packet_transfer_id;
    history.transfer_mode = 'unknown';
    history.orphan_final_chunk = preserveOrphan ? orphan : null;
  };

  if (is_recent) {
    console.debug(
      '[hist][recent][update]',
      'res=',
      history.resolution,
      'part=',
      data.part,
      'progress=',
      data.progress,
      'len=',
      data.time?.length ?? 0,
      'history_progress=',
      history.progress ?? -1,
      'transfer=',
      packet_transfer_id,
      'mode=',
      history.transfer_mode,
      'pending_parts=',
      history.pending_data.map((pending) => pending.part).join(',')
    );
  }

  if (is_start_packet) {
    // Stable transfer ids allow us to separate overlapping loads cleanly. If
    // the firmware still sends per-chunk timestamps, we fall back to the old
    // heuristic path by staying in legacy mode for that transfer.
    const is_new_transfer =
      current_transfer_id === null ||
      packet_transfer_id === null ||
      packet_transfer_id !== current_transfer_id;
    const should_reset_pending = is_recent || history.pending_data.length === 0 || is_new_transfer;
    if (should_reset_pending) {
      resetPendingTransfer();
    } else if (history.pending_transfer_id === null) {
      history.pending_transfer_id = packet_transfer_id;
    }
    history.progress = 0;
    history.incomplete_final_chunk = false;
  } else if (!is_recent && !has_active_transfer && data.progress === 100) {
    // Full/daily may occasionally deliver the final chunk before any earlier
    // chunk. Keep it aside so a later non-final chunk can still complete the
    // transfer, but don't show a fake 99% stuck state from a lone tail packet.
    history.orphan_final_chunk = data;
    history.incomplete_final_chunk = true;
    history.progress = 0;
    return history;
  }

  if (!is_start_packet && has_active_transfer) {
    if (history.transfer_mode === 'unknown') {
      if (supportsStableTransferId && packet_transfer_id !== null && current_transfer_id !== null) {
        if (packet_transfer_id === current_transfer_id) {
          history.transfer_mode = 'strict';
        } else {
          history.transfer_mode = 'legacy';
        }
      } else {
        history.transfer_mode = 'legacy';
      }
    }

    if (
      !is_recent &&
      history.transfer_mode === 'strict' &&
      packet_transfer_id !== null &&
      current_transfer_id !== null &&
      packet_transfer_id !== current_transfer_id
    ) {
      // A retried full/daily load may reach the browser without its new
      // part-0/start packet. When that happens, the new transfer id must take
      // over immediately or the UI will keep retrying forever while ignoring
      // the replacement chunks.
      history.pending_data = [];
      history.pending_transfer_id = packet_transfer_id;
      history.transfer_mode = 'strict';
      history.orphan_final_chunk = null;
      history.incomplete_final_chunk = false;
      has_active_transfer = false;
    }
  }

  // Update history-infos
  const existing_index = history.pending_data.findIndex((pending) => pending.part === data.part);
  if (existing_index !== -1) {
    history.pending_data[existing_index] = data;
  } else {
    history.pending_data.push(data);
  }

  if (!is_recent && history.orphan_final_chunk !== null) {
    const orphan = history.orphan_final_chunk;
    const can_merge_orphan =
      !supportsStableTransferId ||
      history.transfer_mode !== 'strict' ||
      history.pending_transfer_id === null ||
      orphan.timestamp === history.pending_transfer_id;
    const orphan_exists = history.pending_data.some((pending) => pending.part === orphan.part);
    if (can_merge_orphan && !orphan_exists) {
      history.pending_data.push(orphan);
    }
    history.orphan_final_chunk = null;
  }

  history.progress = Math.min(99, Math.max(history.progress ?? 0, data['progress']));
  if (data.time.length > 0) {
    history.last_ts = data.time[data.time.length - 1];
  } else {
    var date = new Date();
    history.last_ts = date.getTime();
  }
  if (is_recent) {
    if (data['progress'] === 100) {
      history.pending_data.sort((a, b) => a.part - b.part);
      ClearHistoryValues(history);
      for (const data of history.pending_data) {
        UpdateHistoryValues(history, data);
      }
      NormalizeHistoryOrder(history);
      history.progress = 100;
      history.pending_data = [];
      history.pending_transfer_id = null;
      history.transfer_mode = 'unknown';
      console.debug(
        '[hist][recent][finalized]',
        'points=',
        history.time.length,
        'from=',
        history.time[0],
        'to=',
        history.time.at(-1)
      );
    }
    return history;
  }

  // Daily/full: only publish once the last chunk has arrived and all parts are present.
  const saw_final_chunk = history.pending_data.some((pending) => pending.progress === 100);
  if (saw_final_chunk) {
    history.pending_data.sort((a, b) => {
      if (a.part !== b.part) return a.part - b.part;
      const a_first = a.time?.length > 0 ? a.time[0] : 0;
      const b_first = b.time?.length > 0 ? b.time[0] : 0;
      return a_first - b_first;
    });

    const min_part = history.pending_data[0]?.part ?? 0;
    const max_part = history.pending_data[history.pending_data.length - 1]?.part ?? 0;
    const has_contiguous_parts = history.pending_data.every(
      (pending, index) => pending.part === min_part + index
    );
    const has_non_final_prefix = history.pending_data.some((pending) => pending.progress < 100);
    const is_lone_trailing_final = min_part > 0 && !has_non_final_prefix;
    const is_missing_initial_part = supportsStableTransferId && min_part !== 0;

    // Stable-id transfers always start at part 0. Do not publish a contiguous
    // suffix when its initial chunk was dropped; mark it incomplete so the
    // existing whole-request retry can fetch the complete history.
    if (
      !has_contiguous_parts ||
      is_missing_initial_part ||
      is_lone_trailing_final ||
      max_part < min_part
    ) {
      // With stable transfer ids, a final packet plus missing earlier/middle
      // parts is still an incomplete transfer. Keep the gathered chunks so late
      // packets can still complete it, but mark it incomplete so the graph can
      // schedule a retry instead of sitting at 99% forever.
      history.incomplete_final_chunk = true;
      if (is_lone_trailing_final) {
        history.pending_data = [];
        history.orphan_final_chunk = data;
        history.progress = 0;
      }
      return history;
    }

    ClearHistoryValues(history);
    for (const data of history.pending_data) {
      UpdateHistoryValues(history, data);
    }
    NormalizeHistoryOrder(history);
    history.pending_data = [];
    history.pending_transfer_id = null;
    history.transfer_mode = 'unknown';
    history.progress = 100;
    history.incomplete_final_chunk = false;
    history.orphan_final_chunk = null;
  }
  return history;
}

function ClearHistoryValues(cur) {
  for (const type of HISTORY_TYPES) cur[type] = [];
}

function UpdateHistoryValues(cur, next) {
  // If next history values don't exist, create with matching length
  if (!('vol_water_content_2' in next) || next['vol_water_content_2'].length === 0) {
    const len = next['time'].length;
    for (const type of [
      'vol_water_content_2',
      'ec_root_zone_2',
      'vol_water_content_3',
      'ec_root_zone_3',
      'vol_water_content_4',
      'ec_root_zone_4'
    ]) {
      next[type] = [
        ...Array.from(
          Array(len)
            .fill()
            .map((_, i) => 0xffff)
        )
      ];
    }
  }
  // Update history with transformed values
  for (const type of HISTORY_TYPES) {
    cur[type].push(...next[type].map((val) => TransformHistoryValue(val, type)));
  }
}

function NormalizeHistoryOrder(history) {
  if (!history?.time || history.time.length <= 1) return;

  const rows = [];
  for (let i = 0; i < history.time.length; i++) {
    const ts = history.time[i];
    if (ts === undefined || ts === null) continue;

    const row = { time: ts };
    for (const type of HISTORY_TYPES) {
      row[type] = history[type][i];
    }
    rows.push(row);
  }

  rows.sort((a, b) => a.time - b.time);

  const deduped = [];
  for (const row of rows) {
    if (deduped.length > 0 && deduped[deduped.length - 1].time === row.time) {
      deduped[deduped.length - 1] = row;
    } else {
      deduped.push(row);
    }
  }

  ClearHistoryValues(history);
  for (const row of deduped) {
    for (const type of HISTORY_TYPES) {
      history[type].push(row[type]);
    }
  }
}

export function PrintDate(timestamp, format, unknownTime = 'n/a') {
  // Match the controller RTC's calendar years (2000-2099). In particular,
  // an unset clock must not appear as a real date near the Unix epoch.
  if (typeof timestamp !== 'number' || timestamp < 946684800000 || timestamp >= 4102444800000)
    return unknownTime;
  const date = momentWithLocale(timestamp).utc();
  return date.isValid() ? date.format(format) : unknownTime;
}

// safely handles circular references
export function dump(obj, indent = 2) {
  let cache = [];
  let str = JSON.stringify(
    obj,
    (key, value) =>
      typeof value === 'object' && value !== null
        ? cache.includes(value)
          ? undefined // Duplicate reference found, discard key
          : cache.push(value) && value // Store value in our collection
        : value,
    indent
  );
  cache = null;
  return str;
}

export function BinaryToUintArray(binary_str, len) {
  var array = new Uint8Array(len);
  for (var i = 0; i < len; i++) {
    array[i] = binary_str.charCodeAt(i);
  }
  return array;
}

// https://gist.github.com/manast/1185904
// start:
// `let timer = new Interval (500, () => { ... });`
// `timer.start();`
// stop:
// `timer.stop();`
export function Interval(fn, duration) {
  var _this = this;
  this.baseline = undefined;

  this.run = function () {
    if (_this.baseline === undefined) {
      _this.baseline = new Date().getTime();
    }
    fn();
    var end = new Date().getTime();
    _this.baseline += duration;

    var nextTick = duration - (end - _this.baseline);
    if (nextTick <= 0) {
      // Poll current state once; missed ticks must not create a request burst.
      _this.baseline = end;
      nextTick = duration;
    }

    _this.timer = setTimeout(function () {
      _this.run(end);
    }, nextTick);
  };

  this.stop = function () {
    clearTimeout(_this.timer);
  };
}

export function setImmediatelyInterval(func, delay) {
  func();
  return setInterval(func, delay);
}

export function makeScheduleTankFilling(tank) {
  const refillAvailable = tank.refill_strategy !== undefined && tank.refill_strategy !== 255;
  return {
    tank_id: tank.tank_id,
    selected_route_id: tank.selected_route_id ?? 0,
    refill_strategy: refillAvailable ? tank.refill_strategy : 0,
    fill_timeout_seconds: refillAvailable ? tank.fill_timeout_seconds : 0,
    planned_offset_minutes: refillAvailable ? tank.planned_offset_minutes : 0
  };
}

export function makePhase(init) {
  const phase = {
    name_phase_short: init.name_phase_short || '',
    name_phase_full: init.name_phase_full || '',
    phase_id: init.phase_id ?? -1,
    humidity_sp_day: init.humidity_sp_day || 0,
    humidity_sp_night: init.humidity_sp_night || 0,
    temp_sp_day: init.temp_sp_day || 0,
    temp_sp_night: init.temp_sp_night || 0,
    vpd_sp: init.vpd_sp || 0,
    vpd_sp_night: init.vpd_sp_night || 0,
    vpd_calc_enable: init.vpd_calc_enable || 0,
    temp_sp_heating_mat_day_rel: init.temp_sp_heating_mat_day_rel || 0,
    temp_sp_heating_mat_night_rel: init.temp_sp_heating_mat_night_rel || 0,
    temp_sp_heating_mat_day_abs: init.temp_sp_heating_mat_day_abs || 0,
    temp_sp_heating_mat_night_abs: init.temp_sp_heating_mat_night_abs || 0,
    toggle_temp_heating_mat_day: init.toggle_temp_heating_mat_day || 0,
    toggle_temp_heating_mat_night: init.toggle_temp_heating_mat_night ?? 1,
    co2_control: init.co2_control || 0,
    co2_sp: init.co2_sp || 0,
    temp_sp_co2: init.temp_sp_co2 || 0,
    lights_max_1: init.lights_max_1 || 0,
    lights_max_2: init.lights_max_2 || 0,
    lights_max_3: init.lights_max_3 || 0,
    lights_max_4: init.lights_max_4 || 0,
    nutrient_settings_count: init.nutrient_settings_count ?? 4,
    nutrient_settings: init.nutrient_settings || [
      {
        ec_setpoint: init.ec_setpoint || 0,
        ph_setpoint: init.ph_setpoint || 0,
        temp_setpoint: init.temp_setpoint || 0,
        pump_cnt_used: init.pump_cnt_used || 4,
        pumps: init.pumps || [
          {
            type: init.type || 0,
            unit: init.unit || 0,
            value: init.value || 0,
            name: init.name || ''
          },
          {
            type: init.type || 0,
            unit: init.unit || 0,
            value: init.value || 0,
            name: init.name || ''
          },
          {
            type: init.type || 0,
            unit: init.unit || 0,
            value: init.value || 0,
            name: init.name || ''
          },
          {
            type: init.type || 0,
            unit: init.unit || 0,
            value: init.value || 0,
            name: init.name || ''
          }
        ]
      },
      {
        ec_setpoint: init.ec_setpoint || 0,
        ph_setpoint: init.ph_setpoint || 0,
        temp_setpoint: init.temp_setpoint || 0,
        pump_cnt_used: init.pump_cnt_used || 4,
        pumps: init.pumps || [
          {
            type: init.type || 0,
            unit: init.unit || 0,
            value: init.value || 0,
            name: init.name || ''
          },
          {
            type: init.type || 0,
            unit: init.unit || 0,
            value: init.value || 0,
            name: init.name || ''
          },
          {
            type: init.type || 0,
            unit: init.unit || 0,
            value: init.value || 0,
            name: init.name || ''
          },
          {
            type: init.type || 0,
            unit: init.unit || 0,
            value: init.value || 0,
            name: init.name || ''
          }
        ]
      },
      {
        ec_setpoint: init.ec_setpoint || 0,
        ph_setpoint: init.ph_setpoint || 0,
        temp_setpoint: init.temp_setpoint || 0,
        pump_cnt_used: init.pump_cnt_used || 4,
        pumps: init.pumps || [
          {
            type: init.type || 0,
            unit: init.unit || 0,
            value: init.value || 0,
            name: init.name || ''
          },
          {
            type: init.type || 0,
            unit: init.unit || 0,
            value: init.value || 0,
            name: init.name || ''
          },
          {
            type: init.type || 0,
            unit: init.unit || 0,
            value: init.value || 0,
            name: init.name || ''
          },
          {
            type: init.type || 0,
            unit: init.unit || 0,
            value: init.value || 0,
            name: init.name || ''
          }
        ]
      },
      {
        ec_setpoint: init.ec_setpoint || 0,
        ph_setpoint: init.ph_setpoint || 0,
        temp_setpoint: init.temp_setpoint || 0,
        pump_cnt_used: init.pump_cnt_used || 4,
        pumps: init.pumps || [
          {
            type: init.type || 0,
            unit: init.unit || 0,
            value: init.value || 0,
            name: init.name || ''
          },
          {
            type: init.type || 0,
            unit: init.unit || 0,
            value: init.value || 0,
            name: init.name || ''
          },
          {
            type: init.type || 0,
            unit: init.unit || 0,
            value: init.value || 0,
            name: init.name || ''
          },
          {
            type: init.type || 0,
            unit: init.unit || 0,
            value: init.value || 0,
            name: init.name || ''
          }
        ]
      }
    ],
    irrigation_settings_count: init.irrigation_settings_count ?? 4,
    irrigation_settings: init.irrigation_settings || [
      {
        enable_irrigation: init.enable_irrigation || 0,
        irrigation_p0_dry_back_abs: init.irrigation_p0_dry_back_abs || 0,
        irrigation_p2_offset_target_vwc: init.irrigation_p2_offset_target_vwc || 0,
        irrigation_p2_target_vwc_abs: init.irrigation_p2_target_vwc_abs || 0,
        irrigation_p2_dry_back_abs: init.irrigation_p2_dry_back_abs || 0,
        irrigation_p2_end_before_sunset: init.irrigation_p2_end_before_sunset || '00:00:00'
      },
      {
        enable_irrigation: init.enable_irrigation || 0,
        irrigation_p0_dry_back_abs: init.irrigation_p0_dry_back_abs || 0,
        irrigation_p2_offset_target_vwc: init.irrigation_p2_offset_target_vwc || 0,
        irrigation_p2_target_vwc_abs: init.irrigation_p2_target_vwc_abs || 0,
        irrigation_p2_dry_back_abs: init.irrigation_p2_dry_back_abs || 0,
        irrigation_p2_end_before_sunset: init.irrigation_p2_end_before_sunset || '00:00:00'
      },
      {
        enable_irrigation: init.enable_irrigation || 0,
        irrigation_p0_dry_back_abs: init.irrigation_p0_dry_back_abs || 0,
        irrigation_p2_offset_target_vwc: init.irrigation_p2_offset_target_vwc || 0,
        irrigation_p2_target_vwc_abs: init.irrigation_p2_target_vwc_abs || 0,
        irrigation_p2_dry_back_abs: init.irrigation_p2_dry_back_abs || 0,
        irrigation_p2_end_before_sunset: init.irrigation_p2_end_before_sunset || '00:00:00'
      },
      {
        enable_irrigation: init.enable_irrigation || 0,
        irrigation_p0_dry_back_abs: init.irrigation_p0_dry_back_abs || 0,
        irrigation_p2_offset_target_vwc: init.irrigation_p2_offset_target_vwc || 0,
        irrigation_p2_target_vwc_abs: init.irrigation_p2_target_vwc_abs || 0,
        irrigation_p2_dry_back_abs: init.irrigation_p2_dry_back_abs || 0,
        irrigation_p2_end_before_sunset: init.irrigation_p2_end_before_sunset || '00:00:00'
      }
    ],
    time_day_start: init.time_day_start || '00:00:00',
    time_day_end: init.time_day_end || '00:00:00',
    time_interval_1_on_day: init.time_interval_1_on_day || '00:00:00',
    time_interval_1_off_day: init.time_interval_1_off_day || '00:00:00',
    time_interval_1_on_night: init.time_interval_1_on_night || '00:00:00',
    time_interval_1_off_night: init.time_interval_1_off_night || '00:00:00',
    time_interval_2_on_day: init.time_interval_2_on_day || '00:00:00',
    time_interval_2_off_day: init.time_interval_2_off_day || '00:00:00',
    time_interval_2_on_night: init.time_interval_2_on_night || '00:00:00',
    time_interval_2_off_night: init.time_interval_2_off_night || '00:00:00',
    time_event1_start: init.time_event1_start || '00:00:00',
    time_event1_duration: init.time_event1_duration || '00:00:00',
    time_event1_exec_gap: init.time_event1_exec_gap || 0,
    time_event2_start: init.time_event2_start || '00:00:00',
    time_event2_duration: init.time_event2_duration || '00:00:00',
    time_event2_exec_gap: init.time_event2_exec_gap || 0,
    time_event3_start: init.time_event3_start || '00:00:00',
    time_event3_duration: init.time_event3_duration || '00:00:00',
    time_event3_exec_gap: init.time_event3_exec_gap || 0,
    time_event4_start: init.time_event4_start || '00:00:00',
    time_event4_duration: init.time_event4_duration || '00:00:00',
    time_event4_exec_gap: init.time_event4_exec_gap || 0,
    time_event5_start: init.time_event5_start || '00:00:00',
    time_event5_duration: init.time_event5_duration || '00:00:00',
    time_event5_exec_gap: init.time_event5_exec_gap || 0,
    time_event6_start: init.time_event6_start || '00:00:00',
    time_event6_duration: init.time_event6_duration || '00:00:00',
    time_event6_exec_gap: init.time_event6_exec_gap || 0,
    time_event7_start: init.time_event7_start || '00:00:00',
    time_event7_duration: init.time_event7_duration || '00:00:00',
    time_event7_exec_gap: init.time_event7_exec_gap || 0,
    time_event8_start: init.time_event8_start || '00:00:00',
    time_event8_duration: init.time_event8_duration || '00:00:00',
    time_event8_exec_gap: init.time_event8_exec_gap || 0,
    irrigation_event_count: init.irrigation_event_count ?? init.irrigation_events?.length ?? 0,
    irrigation_events: DeepCopyObj(init.irrigation_events ?? []),
    circulation: DeepCopyObj(init.circulation ?? Array.from({ length: 4 }, () => ({ day: 50, night: 50, co2: 50 }))),
    tank_filling: DeepCopyObj(init.tank_filling ?? [])
  };
  if (init.lighting) phase.lighting = DeepCopyObj(init.lighting);
  // Native Industrial Pro phase timers retain their physical IDs and nested cycles.
  for (const key of ['interval_timer', 'event_timer']) {
    if (init[key] !== undefined) phase[key] = DeepCopyObj(init[key]);
  }
  phase.nutrient_settings = DeepCopyObj(phase.nutrient_settings);
  phase.irrigation_settings = phase.irrigation_settings.map((irrigation) => ({
    enable_irrigation: irrigation?.enable_irrigation ?? 0,
    selected_tank_id: irrigation?.selected_tank_id ?? 0,
    irrigation_time_exec_gap_days: irrigation?.irrigation_time_exec_gap_days ?? 0,
    irrigation_p0_enable: irrigation?.irrigation_p0_enable ?? 0,
    irrigation_p0_enable_timeout: irrigation?.irrigation_p0_enable_timeout ?? 0,
    irrigation_p0_dry_back_abs: irrigation?.irrigation_p0_dry_back_abs ?? 0,
    irrigation_p0_phase_timeout_minutes: irrigation?.irrigation_p0_phase_timeout_minutes ?? 0,
    irrigation_p1_shot_size_vwc_rel: irrigation?.irrigation_p1_shot_size_vwc_rel ?? 0,
    irrigation_p1_target_vwc_abs: irrigation?.irrigation_p1_target_vwc_abs ?? 0,
    irrigation_p1_auto_vwc_exec_gap_days: irrigation?.irrigation_p1_auto_vwc_exec_gap_days ?? 0,
    irrigation_p1_wait_after_shot_minutes:
      irrigation?.irrigation_p1_wait_after_shot_minutes ?? 0,
    irrigation_p2_offset_target_vwc: irrigation?.irrigation_p2_offset_target_vwc ?? 0,
    irrigation_p2_target_vwc_abs: irrigation?.irrigation_p2_target_vwc_abs ?? 0,
    irrigation_p2_dry_back_abs: irrigation?.irrigation_p2_dry_back_abs ?? 0,
    irrigation_p2_wait_after_shot_s: irrigation?.irrigation_p2_wait_after_shot_s ?? 0,
    irrigation_p2_interval_on_duration_seconds:
      irrigation?.irrigation_p2_interval_on_duration_seconds ?? 0,
    irrigation_p2_interval_off_duration_minutes:
      irrigation?.irrigation_p2_interval_off_duration_minutes ?? 0,
    irrigation_p2_end_before_sunset:
      irrigation?.irrigation_p2_end_before_sunset ?? '00:00:00',
    irrigation_p3_min_vwc_abs: irrigation?.irrigation_p3_min_vwc_abs ?? 0
  }));
  return phase;
}

function schedulingTime(settings, prefix, minuteKey = 'min', includeSeconds = true) {
  const part = (suffix) => {
    const value = Number(settings?.[`${prefix}_${suffix}`]);
    return String(Number.isFinite(value) ? value : 0).padStart(2, '0');
  };

  return `${part('hour')}:${part(minuteKey)}:${includeSeconds ? part('sec') : '00'}`;
}

export function makePhaseFromZoneSettings(
  zoneSettings,
  phaseId,
  name = 'Your Name',
  co2Temperature = zoneSettings?.co2?.temp_sp_co2,
  tanks = []
) {
  const climate = zoneSettings?.climate ?? {};
  const co2 = zoneSettings?.co2 ?? {};
  const lights = zoneSettings?.lights ?? {};
  const nutrition = zoneSettings?.nutrition ?? {};
  const irrigation = zoneSettings?.irrigation ?? {};
  const timing = zoneSettings?.timing ?? {};
  const nutrientSettings = nutrition.nutrient_settings ?? [
    {
      ec_setpoint: nutrition.ec_setpoint ?? 0,
      ph_setpoint: nutrition.ph_setpoint ?? 0,
      temp_setpoint: nutrition.temp_setpoint ?? 0,
      pump_cnt_used: nutrition.pump_cnt_used ?? nutrition.pumps?.length ?? 0,
      pumps: nutrition.pumps ?? []
    }
  ];
  const irrigationSettings = irrigation.irrigation_settings ?? [];
  const irrigationEvents = irrigation.irrigation_events ?? [];

  const init = {
    name_phase_short: name,
    name_phase_full: name,
    phase_id: phaseId,
    humidity_sp_day: climate.humidity_sp_day,
    humidity_sp_night: climate.humidity_sp_night,
    temp_sp_day: climate.temp_sp_day,
    temp_sp_night: climate.temp_sp_night,
    vpd_sp: climate.vpd_sp,
    vpd_sp_night: climate.vpd_sp_night,
    vpd_calc_enable: climate.vpd_calc_enable,
    temp_sp_heating_mat_day_rel: climate.temp_sp_heating_mat_day_rel,
    temp_sp_heating_mat_night_rel: climate.temp_sp_heating_mat_night_rel,
    temp_sp_heating_mat_day_abs: climate.temp_sp_heating_mat_day_abs,
    temp_sp_heating_mat_night_abs: climate.temp_sp_heating_mat_night_abs,
    toggle_temp_heating_mat_day: climate.toggle_temp_heating_mat_day,
    toggle_temp_heating_mat_night: climate.toggle_temp_heating_mat_night,
    co2_control: co2.co2_control,
    co2_sp: co2.co2_sp,
    temp_sp_co2: co2Temperature,
    lights_max_1: lights.lights_max,
    lights_max_2: lights.lights_max_2,
    lights_max_3: lights.lights_max_3,
    lights_max_4: lights.lights_max_4,
    nutrient_settings_count: nutrientSettings.length,
    nutrient_settings: nutrientSettings,
    irrigation_settings_count: irrigationSettings.length,
    irrigation_settings: irrigationSettings,
    irrigation_event_count: irrigationEvents.length,
    irrigation_events: irrigationEvents,
    circulation: zoneSettings?.ventilation?.circulation,
    tank_filling: tanks.map(makeScheduleTankFilling),
    interval_timer: timing.interval_timer,
    event_timer: timing.event_timer,
    time_day_start: schedulingTime(timing, 'start_day', 'min', false),
    time_day_end: schedulingTime(timing, 'end_day', 'min', false),
    time_interval_1_on_day: schedulingTime(timing, 'interval_on_day'),
    time_interval_1_off_day: schedulingTime(timing, 'interval_off_day'),
    time_interval_1_on_night: schedulingTime(timing, 'interval_on_night'),
    time_interval_1_off_night: schedulingTime(timing, 'interval_off_night'),
    time_interval_2_on_day: schedulingTime(timing, 'time_interval_2_on_day', 'minute'),
    time_interval_2_off_day: schedulingTime(timing, 'time_interval_2_off_day', 'minute'),
    time_interval_2_on_night: schedulingTime(timing, 'time_interval_2_on_night', 'minute'),
    time_interval_2_off_night: schedulingTime(timing, 'time_interval_2_off_night', 'minute')
  };

  for (let eventId = 1; eventId <= 8; eventId += 1) {
    init[`time_event${eventId}_start`] = schedulingTime(
      timing,
      `event${eventId}_start`,
      'min',
      false
    );
    init[`time_event${eventId}_duration`] = schedulingTime(
      timing,
      `event${eventId}_duration`
    );
    init[`time_event${eventId}_exec_gap`] = timing[`time_event${eventId}_exec_gap`] ?? 0;
  }

  return makePhase(init);
}

export function cloneSchedulePhase(previousPhase, phaseId, name = 'Your Name') {
  return makePhase({
    ...DeepCopyObj(previousPhase),
    name_phase_short: name,
    name_phase_full: name,
    phase_id: phaseId,
    _deleted: undefined
  });
}

export function makeMultiOutObject(controller, parent) {
  if (controller.type >= 6000 || controller.type === 5155) {
    let slaves = {};
    if (controller.access_rights.multi_io?.read !== true) return slaves;
    for (let s of controller.slaves) {
      for (let mo of Object.values(s.multi_outs ?? {}).filter((mo) => {
        return parent !== undefined ? mo.zone === parent.zone_id : true;
      })) {
        if (!(s.address in slaves)) {
          slaves[s.address] = {};
        }
        // Correct bitshifted type-id (= hw_type for 5155)
        if (controller.type === 5155) {
          let copied = DeepCopyObj(mo);
          copied.type_id = mo.type_id >>> 4;
          slaves[s.address][mo.id] = copied;
        } else {
          slaves[s.address][mo.id] = mo;
        }
      }
    }
    return slaves;
  } else {
    let multi_outs = [];
    if (controller.access_rights.multi_io?.read !== true) return multi_outs;
    const multiOutValues = parent?.settings?.multi_out_values;
    const multiOutSettings = parent?.settings?.multi_out;
    if (!multiOutValues || !multiOutSettings) return multi_outs;

    for (let i = 1; i <= (multiOutValues.out_count ?? 0); i++) {
      let mo = {
        id: i,
        state: multiOutValues['out_' + i + '_state'],
        func: multiOutSettings['out_' + i + '_func'],
        type: multiOutSettings['out_' + i + '_type'],
        memo: multiOutSettings['out_' + i + '_memo']
      };
      multi_outs.push(mo);
    }
    return multi_outs;
  }
}

export function makeOverwrIOObject(controller, parent) {
  let overwr_io = { functions_used_cnt: 0, oios: [] };
  if (controller.access_rights.multi_io?.read !== true) {
    return {};
  }
  if (!controller.overwr_io) {
    return overwr_io;
  }
  overwr_io.functions_used_cnt = controller.overwr_io.functions_used_cnt ?? 0;

  // Filter by zone if parent is defined
  const oios =
    parent !== undefined
      ? controller.overwr_io.oios.filter((oio) => oio.zone === (parent.zone_id ?? parent.id))
      : controller.overwr_io.oios;

  for (let i = 0; i < oios.length ?? 0; i++) {
    overwr_io.oios.push({
      zone: oios[i].zone,
      function: oios[i].function,
      func_index: oios[i].func_index,
      select: oios[i].select,
      val_ana: oios[i].val_ana,
      add_sett: oios[i].add_sett,
      timeout: oios[i].timeout
    });
  }
  return overwr_io;
}

export function makeExtReadingsObject(controller, parent) {
  let ext_readings = { external_readings_used_cnt: 0, extrs: [] };
  if (controller.access_rights.ext_readings.read !== true) {
    return {};
  }
  if (!controller.ext_readings) {
    return ext_readings;
  }
  ext_readings.external_readings_used_cnt = controller.ext_readings.external_readings_used_cnt ?? 0;

  // Filter by zone if parent is defined
  const extrs =
    parent !== undefined
      ? controller.ext_readings.extrs.filter(
          (external_reading) => external_reading.zone === parent.id
        )
      : controller.ext_readings.extrs;

  for (let i = 0; i < extrs.length ?? 0; i++) {
    ext_readings.extrs.push({
      gcl_addr: extrs[i].gcl_addr,
      port_id: extrs[i].port_id,
      addr_sensor: extrs[i].addr_sensor,
      sensor_addr_display_type: extrs[i].sensor_addr_display_type,
      zone: extrs[i].zone,
      sub_zone: extrs[i].sub_zone,
      type: extrs[i].type,
      value: extrs[i].value,
      exclude_cur_value: extrs[i].exclude_cur_value
    });
  }
  return ext_readings;
}

export function makeAHUInfoObject(controller, parent, filter_by_zone = true) {
  let ahu_info = { ahu_unit_info_cnt: 0, ahui: [] };
  if (controller.access_rights.ahu_info.read !== true) {
    return {};
  }
  if (!controller.ahu_info) {
    return ahu_info;
  }
  ahu_info.ahu_unit_info_cnt = controller.ahu_info.ahu_unit_info_cnt ?? 0;

  // Filter by zone if parent is defined
  const ahui =
    filter_by_zone && parent !== undefined
      ? controller.ahu_info.ahui.filter((ahu) => ahu.zone === parent.zone_id)
      : controller.ahu_info.ahui.filter((ahu) => ahu.zone === '254');

  for (let i = 0; i < ahui.length ?? 0; i++) {
    ahu_info.ahui.push({
      show_this_unit: ahui[i].show_this_unit,
      slave_status: ahui[i].slave_status,
      ahu_id: ahui[i].ahu_id,
      zone: ahui[i].zone,
      index_per_zone: ahui[i].index_per_zone,
      type_id: ahui[i].type_id,
      temp_air_info: ahui[i].temp_air_info,
      temp_air_info_type: ahui[i].temp_air_info_type,
      temp_air_outdoor: ahui[i].temp_air_outdoor,
      temp_air_supply: ahui[i].temp_air_supply,
      temp_air_extract: ahui[i].temp_air_extract,
      temp_air_exhaust: ahui[i].temp_air_exhaust,
      temp_air_indoor: ahui[i].temp_air_indoor,
      flow_air_supply: ahui[i].flow_air_supply,
      flow_air_extract: ahui[i].flow_air_extract,
      fan_power_current: ahui[i].fan_power_current,
      bypass_position_current: ahui[i].bypass_position_current,
      init_state: ahui[i].init_state,
      operational_state: ahui[i].operational_state,
      alarm_code: ahui[i].alarm_code,
      warning_code: ahui[i].warning_code,
      filter_hours_current: ahui[i].filter_hours_current,
      filter_hours_threshold: ahui[i].filter_hours_threshold,
      heat_recovery_efficiency_percent: ahui[i].heat_recovery_efficiency_percent
    });
  }
  return ahu_info;
}

export function makeAHUUnitObject(controller, parent, filter_by_zone = true) {
  let ahu_unit = { ahu_unit_used_cnt: 0, ahus: [] };
  if (controller.access_rights.ahu_unit.read !== true) {
    return {};
  }
  if (!controller.ahu_unit) {
    return ahu_unit;
  }
  ahu_unit.ahu_unit_used_cnt = controller.ahu_unit.ahu_unit_used_cnt ?? 0;

  // Filter by zone if parent is defined
  const ahus =
    filter_by_zone && parent !== undefined
      ? controller.ahu_unit.ahus.filter((ahu) => ahu.zone === parent.zone_id)
      : controller.ahu_unit.ahus.filter((ahu) => ahu.zone === '254');

  for (let i = 0; i < ahus.length ?? 0; i++) {
    ahu_unit.ahus.push({
      show_this_unit: ahus[i].show_this_unit,
      ahu_id: ahus[i].ahu_id,
      zone: ahus[i].zone,
      index_per_zone: ahus[i].index_per_zone,
      type_id: ahus[i].type_id,
      name: ahus[i].name,
      mode: ahus[i].mode,
      fan_steps: ahus[i].fan_steps,
      fan_power_setpoint_day: ahus[i].fan_power_setpoint_day,
      fan_power_setpoint_night: ahus[i].fan_power_setpoint_night,
      fan_power_setpoint_co2: ahus[i].fan_power_setpoint_co2,
      fan_power_contr_mode: ahus[i].fan_power_contr_mode,
      bypass_steps: ahus[i].bypass_steps,
      bypass_position_setpoint_day: ahus[i].bypass_position_setpoint_day,
      bypass_position_setpoint_night: ahus[i].bypass_position_setpoint_night,
      bypass_position_setpoint_co2: ahus[i].bypass_position_setpoint_co2,
      bypass_control_mode: ahus[i].bypass_control_mode
    });
  }
  return ahu_unit;
}

export function makeSlaveInfoObject(controller, parent) {
  if (controller.type === 5155) {
    let slaves_infos = {};
    const slaveInfos = parent?.infos?.slave_infos ?? [];
    for (let i = 0; i < slaveInfos.length; i++) {
      let si = {
        index: i,
        address: slaveInfos[i].slave_address,
        status: slaveInfos[i].slave_status,
        elapsed_time: slaveInfos[i].slave_elapsed_time
      };
      if (!(si.address in slaves_infos)) {
        slaves_infos[si.address] = {};
      }
      slaves_infos[si.address] = si;
    }
    return slaves_infos;
  }
}

export function isZoned(controller) {
  return isZonable(controller) && (controller.zoned ?? false);
}

export function GetZoneName(controller, zone_id) {
  const zones = Object.values(controller.zones)
    .map((z) => ({ value: String(z.id), label: z.name }))
    .concat([
      { value: String(0xfe), label: 'global' },
      { value: String(0xff), label: 'undefined' }
    ]);

  const zone = zones.find((z) => z.value === String(zone_id));
  return zone ? zone.label : 'unknown';
}

export function isZonable(controller) {
  return controller.type === 6000 || controller.type === 5155;
}

export function getControllerApiVersion(controller) {
  const apiVersion = [
    controller?.settings?.system?.api_version,
    controller?.system?.api_version,
    controller?.api_version
  ].find((value) => value !== undefined && value !== null && String(value).trim() !== '');

  return String(apiVersion ?? '')
    .trim()
    .toUpperCase();
}

// Root-zone and irrigation support for GrowBase Pro WiFi 5055 starts with API BAD.
const GROWBASE_PRO_WIFI_IRRIGATION_API_MIN = 'BAD';
const LEGACY_GROWBASE_PRO_WIFI_EXCLUDED_FEATURES = {
  tabs: ['irrigation'],
  headlines: [
    'root_zone_hl',
    'root_zone_hl_2',
    'root_zone_hl_3',
    'root_zone_hl_4',
    'irrigation_info_hl',
    'irrigation_info_hl_2',
    'irrigation_info_hl_3',
    'irrigation_info_hl_4'
  ],
  values: []
};

export function IsLegacyGrowBaseProWifiApi(controller) {
  return (
    Number(controller?.type) === 5055 &&
    getControllerApiVersion(controller).localeCompare(GROWBASE_PRO_WIFI_IRRIGATION_API_MIN) < 0
  );
}

export function IsExcludedBasedOnTypeOrProject(controller, id, category = 'values') {
  if (
    IsLegacyGrowBaseProWifiApi(controller) &&
    LEGACY_GROWBASE_PRO_WIFI_EXCLUDED_FEATURES[category]?.includes(id)
  ) {
    return true;
  }

  // Check if ValueBox is excluded for this controller-type
  if (
    controller !== undefined &&
    controller.type in ctef &&
    ctef[controller.type][category].includes(id)
  ) {
    return true;
  }
  if (
    controller !== undefined &&
    controller.project_id in cpef &&
    cpef[controller.project_id][category].includes(id)
  ) {
    return true;
  }
  return false;
}
